//@vendors
const { APIPost } = require('utilities/APIRequestHelper');
const { createActions } = require('redux-actions');

const simpleActions = createActions(
    'INSURANCE_ASSOCIATED_MORTGAGE',
    'INSURANCE_ASSOCIATED_MORTGAGE_ERROR',
    'INSURANCE_ASSOCIATED_MORTGAGE_SUCCESS'
);

const getInsuranceAssociatedMortgage = (contractNumbers = false) => (dispatch, getState) => {

    const mortgagesContractNumberIds = getState().loans.get('byId').reduce((accu, loan) => {
        if (loan.get('isMortgage')) {
            return [...accu, loan.get('newContractNumber')];
        } else {
            return accu;
        }
    }, []);

    const params = {
        query: {
            contractNumbers: contractNumbers ? contractNumbers : mortgagesContractNumberIds
        }
    };

    dispatch(simpleActions.insuranceAssociatedMortgage());
    return APIPost({ dispatch, endpoint: 'insuranceMortgage', params })
        .then(response => {
            dispatch(simpleActions.insuranceAssociatedMortgageSuccess({ data: response.data }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.insuranceAssociatedMortgageError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

module.exports = {
    simpleActions,
    getInsuranceAssociatedMortgage
};
